export default "__VITE_ASSET__221a5c1e__"